import { fss } from "../Fss-lib.Fable.1.0.3/FssFable.fs.js";
import { combine } from "../Fss-lib.Core.1.0.4/Functions.fs.js";
import { singleton, empty, ofArray } from "../fable-library.3.7.17/List.js";

export function Feliz_prop__prop_fss_Static_72C268A9(properties) {
    return ["className", fss(properties)];
}

export function Feliz_prop__prop_fssWithClass_Static(className, properties) {
    return ["className", combine(ofArray([className, fss(properties)]), empty())];
}

export function Feliz_prop__prop_fssCombine_Static(classNames, properties) {
    return ["className", combine(singleton(fss(properties)), classNames)];
}

